import React, { useRef } from 'react';
import { FileText, Upload, Trash2, Download } from 'lucide-react';
import { Button } from './ui/button';
import { documentsAPI } from '../services/api';
import { toast } from 'sonner';

const DocumentRepository = ({ documents, isAdmin, onUpload, onDelete }) => {
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onUpload(files);
      e.target.value = '';
    }
  };

  const handleDownload = async (doc) => {
    try {
      const response = await documentsAPI.download(doc.id, 'gridfs');
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', doc.name);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      toast.error('Erreur lors du téléchargement');
    }
  };

  return (
    <div className="glass rounded-2xl p-6 shadow-xl border border-slate-700/50 animate-slideIn">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <FileText className="w-5 h-5 text-blue-400" />
          Documents
        </h2>
        {isAdmin && (
          <Button
            onClick={() => fileInputRef.current?.click()}
            size="sm"
            className="bg-blue-600 hover:bg-blue-700"
            data-testid="upload-document-btn"
          >
            <Upload className="w-4 h-4 mr-1" />
            Ajouter
          </Button>
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        onChange={handleFileSelect}
        className="hidden"
        data-testid="file-input"
      />

      <div className="space-y-2">
        {documents.length === 0 ? (
          <p className="text-gray-400 text-center py-8" data-testid="no-documents-msg">
            Aucun document disponible
          </p>
        ) : (
          documents.map((doc) => (
            <div
              key={doc.id}
              className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg hover:bg-slate-700/50 transition-colors"
              data-testid={`document-item-${doc.id}`}
            >
              <div className="flex-1 min-w-0">
                <p className="text-white font-medium truncate" data-testid="document-name">
                  {doc.name}
                </p>
                <p className="text-sm text-gray-400">{doc.size}</p>
              </div>
              <div className="flex gap-2 ml-4">
                <Button
                  onClick={() => handleDownload(doc)}
                  size="sm"
                  variant="ghost"
                  className="text-blue-400 hover:text-blue-300"
                  data-testid="download-document-btn"
                >
                  <Download className="w-4 h-4" />
                </Button>
                {isAdmin && (
                  <Button
                    onClick={() => onDelete(doc.id)}
                    size="sm"
                    variant="ghost"
                    className="text-red-400 hover:text-red-300"
                    data-testid="delete-document-btn"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DocumentRepository;